<template>
  <div v-if="ir !== null">
    <!-- Default Messaging -->
    <h3>Default Messaging</h3>
    <div class="py-5">顯示於Investor Relations頁面</div>
    <div>
      <!-- Investor Relations -->
      <div class="form-item d-flex py-5">
        <div class="w-174px mr-6">
          <h4>Investor Relations</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <editor
            v-model="ir.investor_relations"
            :height="200"
            :plugins="'link'"
            :toolbar="'link'">
          </editor>
        </div>
      </div>
      <!-- Transfer Agent -->
      <div class="form-item d-flex py-5">
        <div class="w-174px mr-6">
          <h4>Transfer Agent</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <editor
            v-model="ir.transfer_agent"
            :height="200"
            :plugins="'link'"
            :toolbar="'link'">
          </editor>
        </div>
      </div>

      <!-- Banner -->
      <div class="form-item py-5 d-flex">
        <div class="w-220px mr-6">
          <h4 class="mb-10px">Picture</h4>
          <div class="mb-10px h5 ink-02-medium--text">
            建議尺寸：930px * 550px <br />
            檔案大小限制：≤ 20 MB <br />
            支援格式：.png/.jpg/.gif <br />
          </div>
        </div>
        <div class="flex-grow-1 flex-basis-0 d-flex justify-end">
          <ImgUploader
            :imageUrl.sync="ir.default_messaging_pic"
            dir="ir"></ImgUploader>
        </div>
      </div>
    </div>

    <!-- Quick Link -->
    <h3 class="mt-5">Quick Link</h3>
    <div class="py-5">可編輯文字及連結，可擴充</div>
    <div>
      <!-- items -->
      <PageCollapse v-for="(item, i) in ir.quick_links" :key="i">
        <template v-slot:head>
          <h3 class="mr-auto">Quick Link {{ i + 1 }}</h3>
        </template>
        <template v-slot:actions>
          <div class="ml-auto">
            <button class="btn square mr-10px" @click="deleteItem(i)">
              <v-icon class="ink-02-medium--text">delete</v-icon>
            </button>
            <button class="btn square mr-10px" @click="downItem(item, i)">
              <v-icon class="ink-02-medium--text">arrow_downward</v-icon>
            </button>
            <button class="btn square" @click="upItem(item, i)">
              <v-icon class="ink-02-medium--text">arrow_upward</v-icon>
            </button>
          </div>
        </template>
        <template v-slot:body>
          <!-- label -->
          <label class="px-5 d-flex pb-3">
            <h4 class="w-180px mt-5">Label {{ i + 1 }}</h4>
            <div class="flex-grow-1 mt-3">
              <div class="form-input-group">
                <input type="text" name="title" v-model="item.title" />
              </div>
            </div>
          </label>
          <!-- url -->
          <label class="d-flex px-5 py-2">
            <div class="w-180px">
              <h4 class="mb-10px">URL</h4>
            </div>
            <div class="flex-grow-1 my-n2">
              <div class="form-input-group">
                <v-icon class="prepend-icon">link</v-icon>
                <input type="text" class="pl-42px" v-model="item.url" />
              </div>
            </div>
          </label>
        </template>
      </PageCollapse>

      <!-- add item -->
      <div class="mt-5">
        <button class="btn btn-outlined w-100 justify-start" @click="addItem">
          <v-icon class="primary--text mr-2">add_circle</v-icon>
          <span>添加Partner Endorsement</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import PageCollapse from '@/components/PageCollapse.vue';
import Editor from '@/components/TinymceEditor.vue';
import ImgUploader from '@/components/ImgUploader.vue';

export default {
  props: {
    ir: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    Editor,
    PageCollapse,
    ImgUploader,
  },
  created() {
    if (!this.ir.quick_links) {
      this.ir.quick_links = [];
    }
  },
  data: () => ({}),
  methods: {
    addItem() {
      const template = {
        title: '',
        url: '',
      };
      this.ir.quick_links.push(template);
    },
    deleteItem(index) {
      this.ir.quick_links.splice(index, 1);
    },
    downItem(item, i) {
      // if i is last, then item become the first index
      if (i === this.ir.quick_links.length - 1) {
        this.ir.quick_links.splice(i, 1);
        this.ir.quick_links.unshift(item);
        return;
      }
      // item become next index
      this.ir.quick_links.splice(i, 1);
      this.ir.quick_links.splice(i + 1, 0, item);
    },
    upItem(item, i) {
      // if i = 0, then item go to the last one
      if (i === 0) {
        this.ir.quick_links.splice(i, 1);
        this.ir.quick_links.push(item);
        return;
      }
      // item become previous index
      this.ir.quick_links.splice(i, 1);
      this.ir.quick_links.splice(i - 1, 0, item);
    },
  },
};
</script>

<style></style>
